import Slider from "react-slick";
import { useState } from "react";
import ContactUsModal from "../modal/contact-us";
import { useNavigate } from "react-router-dom";

export const Reviews = () => {
	const navigate = useNavigate();

	const settingsReviews = {
		centerMode: true,
		dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		speed: 1000,
		cssEase: "linear",
		initialSlide: 2,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					arrows: false,
					centerMode: false,
				},
			},
		],
	};

	return (
		<section id="reviews" className="reviews__section">
			<div className="sectionContent">
				<h2 className="h2 clients__title">Что о нас говорят клиенты</h2>

				<div className="reviews__container">
					<Slider className="slider__init" {...settingsReviews}>
						<div className="slider__item">
							<div className="review__slide">
								<a
									href="https://uktlab.ru"
									target="_blank"
									className="review__company"
								>
									ЮКИТЕХ ЛАБ
								</a>
								<div className="review__title">
									Продукт получился понятным и удобным, дизайн-система полностью
									закрыла все наши потребности
								</div>
								<div className="review__content">
									Задачей было спроектировать наш новый продукт по речевой
									аналитике U-Speech Analytics. Ребята с wjet быстро разобрались
									в наших задачах, изучили похожие решения на рынке. Предложили
									отличные идеи по пользовательскому интерфейсу и подаче
									продукта. Придумали уникальные решения, т.к наш продукт и его
									функции инновационные для рынка. Очень понравился подход к
									брендингу — всё выглядит стильно и органично. Смогли
									масштабировать на остальные наши продукты. Работаем вместе уже
									больше года и однозначно рассчитываем на долгосрочное
									сотрудничество и постоянную дизайн поддержку. Спасибо, что
									всегда на связи и подходите к делу с душой!
								</div>
								<div className="review__credits">
									Красюк Василий Юрьевич
									<div className="review__creditposition">
										генеральный директор ООО "ЮКИТЕХ ЛАБ"
									</div>
								</div>
							</div>
						</div>
						<div className="slider__item">
							<div className="review__slide">
								<a
									href="https://www.behance.net/gallery/212489047/BoostPad-UXUI-for-cryptocurrency-launchpad"
									className="review__company"
								>
									BoostPad
								</a>
								<div className="review__title">
									Огромное спасибо за классную работу!
								</div>
								<div className="review__content">
									Получилось именно то, что мы хотели — лаунчпад понятный, без
									лишнего, всё как надо. Отдельный респект за скорость — для нас
									сроки были критически важны, особенно сейчас, когда рынок
									горячий. Благодаря вашей оперативности мы уже получили
									инвестиции и активно привлекаем проекты. Еще раз спасибо за
									профессионализм — работать с вами одно удовольствие!
								</div>
								<div className="review__credits">
									Савельев Алексей
									<div className="review__creditposition">CEO BoostPad</div>
								</div>
							</div>
						</div>
						<div className="slider__item">
							<div className="review__slide">
								<a href="" target="_blank" className="review__company">
									Goodday.work
								</a>
								<div className="review__title">
									Отличная долгосрочная работа по проекту!{" "}
								</div>
								<div className="review__content">
									Мы вместе c wjet, более 7 лет, занимались разработкой Goodday
									Work. Высокая компетентность студии помогла развитию нашего
									продукта. Была выстроена с нуля дизайн система, брендинг,
									дизайн самого продукта и мобильного приложения. Велась плотная
									работа с командой разработки. Надежность и качество на
									протяжении всего периода нашего сотрудничества. Благодарю.
								</div>
								<div className="review__credits">
									Vitali Plugachev
									<div className="review__creditposition">CTO Goodday Work</div>
								</div>
							</div>
						</div>
						{/* <div className="slider__item">
							<div className="review__slide">
								<a href="http://pro-bike.ru" className="review__company">pro-bike</a>
								<div className="review__title"></div>
								<div className="review__content">
									Огромное спасибо за классную работу! Получилось именно то, что
									мы хотели — лаунчпад понятный, без лишнего, всё как надо.
									Отдельный респект за скорость — для нас сроки были критически
									важны, особенно сейчас, когда рынок горячий. Благодаря вашей
									оперативности мы уже получили инвестиции и активно привлекаем
									проекты. Еще раз спасибо за профессионализм — работать с вами
									одно удовольствие!
								</div>
								<div className="review__credits">
									Савельев Алексей
									<div className="review__creditposition">CEO BoostPad</div>
								</div>
							</div>
						</div> */}
						{/* <div className="slider__item">
							<div className="review__slide">
								<div className="review__company">BoostPad</div>
								
								<div className="review__content">
									Огромное спасибо за классную работу! Получилось именно то, что
									мы хотели — лаунчпад понятный, без лишнего, всё как надо.
									Отдельный респект за скорость — для нас сроки были критически
									важны, особенно сейчас, когда рынок горячий. Благодаря вашей
									оперативности мы уже получили инвестиции и активно привлекаем
									проекты. Еще раз спасибо за профессионализм — работать с вами
									одно удовольствие!
								</div>
								<div className="review__credits">
									Савельев Алексей
									<div className="review__creditposition">CEO BoostPad</div>
								</div>
							</div>
						</div> */}
					</Slider>
				</div>
			</div>

			<div className="sectionContent additional__wrapper" id="partnership">
				<div className="additional" id="job">
					<div className="additional__item">
						<div className="additional__title">Партнерам</div>
						<div>
							Мы всегда открыты к сотрудничеству и рады партнёрам, с которыми
							сможем развивать инновационные проекты и создавать уникальные
							цифровые продукты. Будем рады сотрудничать с IT-компаниями,
							стартапами, разработчиками и всеми, кому, как и нам, интересно
							воплощать смелые идеи в жизнь.
						</div>

						<button
							className="additional__action"
							onClick={() => {
								navigate(`?modal`);
							}}
						>
							Обсудить сотрудничество
						</button>
					</div>

					<div className="additional__item">
						<div className="additional__title">Вакансии</div>
						<div>
							Мы постоянно в поиске новых талантов в команду. Открытые вакансии
							сейчас: <br />
							<b>UX/UI Дизайнер</b>
							<br />
							<b>React.js разработчик</b>
							<br />
							<b>Бизнес-аналитик (крипта)</b>
							<br />
							*пишите нам на{" "}
							<a href="mailto:contact@wjet.io" style={{ display: "inline" }}>
								почту
							</a>{" "}
							или в{" "}
							<a href="https://t.me/wjet_io" style={{ display: "inline" }}>
								Telegram(@wjet_io)
							</a>
						</div>

						{/* <button
      className="additional__action"
      onClick={() => {
				navigate(`?modal`);
      }}
    >
      Смотреть вакансии
    </button> */}
					</div>
				</div>
			</div>

			<ContactUsModal />
		</section>
	);
};
